import Swal from 'sweetalert2'
import Loader from '../Components/Loader'
import { Fragment } from 'react'
import ReactDOM from 'react-dom'

var url_json = require('../location.json')

if (window.location.origin.includes('localhost')) {
  url_json = url_json.local
} else {
  url_json = url_json.production
}

const Sesiones = {
  obtenerUnaSesion: async (tipo) => {
    let url = url_json + '/sesion/' + tipo
    let request = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    }

    let response = await fetch(url, request)
    let json = await response.json()
    return { success: response.ok, data: json.data, code: json.message }
  },
  editarSesion: async (data, id) => {
    Swal.fire({
      icon: 'question',
      title: '¿Esta seguro que desea modificar la sesion?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Si',
      denyButtonText: `No`
    }).then(async (result) => {
      if (result.isConfirmed) {
        ReactDOM.render(
          <div className="loader_padre">
            <Loader />
          </div>,
          document.getElementById('loader_padre')
        )

        let url = url_json + '/sesion/' + id

        let body = {
          password: data.password
        }
        let request = {
          method: 'PATCH',
          body: JSON.stringify(body),
          headers: {
            'Content-type': 'application/json; charset=UTF-8'
          }
        }

        let response = await fetch(url, request)
        let res = await response.json()

        ReactDOM.render(
          <Fragment></Fragment>,
          document.getElementById('loader_padre')
        )

        if (response.ok) {
          Swal.fire(
            'Modificación exitosa!',
            'Sesion modificada correctamente',
            'success'
          ).then(() => {
            window.location.reload()
          })
        } else {
          Swal.fire('Error!', 'No se pudo modificar la sesion', 'error').then(
            () => {
              window.location.reload()
            }
          )
        }
        return { success: response.ok, data: res.data }
      } else if (result.isDenied) {
        Swal.fire('Modificación cancelada', 'El campo quedo intacto', 'succes')
      }
    })
  }
}

export default Sesiones
